import { render, staticRenderFns } from "./index-app.vue?vue&type=template&id=566b196e&"
import script from "./index-app.vue?vue&type=script&lang=js&"
export * from "./index-app.vue?vue&type=script&lang=js&"
import style0 from "./index-app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('566b196e', component.options)
    } else {
      api.reload('566b196e', component.options)
    }
    module.hot.accept("./index-app.vue?vue&type=template&id=566b196e&", function () {
      api.rerender('566b196e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/index/index-app.vue"
export default component.exports